import { render } from "./MainProgram.vue?vue&type=template&id=21bf2e12"
import script from "./MainProgram.vue?vue&type=script&lang=js"
export * from "./MainProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__